import React, { useEffect, useState, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import {
  ButtonToolbar,
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Label,
} from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { mdiAccountMinus } from '@mdi/js';
import format from 'date-fns/format';
import Icon from '@mdi/react';
import { cpf } from 'cpf-cnpj-validator';
import MatTable from '../../../shared/components/material-table';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { cpfMasker } from '../../../shared/components/form/Masks';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import DateField from '../../../shared/components/form/DateField';
import Select from '../../../shared/components/form/Select';
import genderSelector from '../../../shared/components/form/GenderSelector';
import AddressInfo from '../../../shared/components/form/AddressInfo';
import ResponsibleForm from '../../Responsible/components/Form';
import MedicalInfo from './MedicalInfo';
import enrollmentsColumns from './EnrollmentsColumns';
import responsibleStudentColumns from './ResponsibleStudentColumns';
import Modal from '../../../shared/components/Modal';
import SmartAvatar from '../../../shared/components/form/SmartAvatar';
import {
  relationStudentActiveClassListToEnroll,
  relationStudentClassListByStudent,
  relationStudentClassRemoveById,
} from '../../../shared/queries/RelationStudentClass';
import {
  responsibleStudentRelationListByStudent,
  responsibleStudentRelationRemoveMutation,
} from '../../../shared/queries/ResponsibleStudentRelation';
import { responsibleSaveMutation } from '../../../shared/queries/Responsible';
import { concatPhones } from '../../../shared/format/format';
import GraphQL from '../../../GraphQL';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import {
  ACTION_NAME,
  ACTIVE_TAB,
  REGEX_NO_EXPRESSIONS,
  STUDENT_AGREEMENT,
} from '../../../shared/utils/constants';
import { getDateWithoutTime } from '../../../shared/utils/smartutils';

const StudentForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    dto,
    initialize,
    fullName,
    change,
    showLoading,
    hideLoading,
    menus,
    historicEnrollments,
    setHistoricEnrollments,
    loadExistStudentByCpf,
  } = props;
  const [activeTab, setActiveTab] = useState(ACTIVE_TAB.ONE);
  const [availableEnrollments, setAvailableEnrollments] = useState([]);
  const [classEnrollmentToAdd, setClassEnrollmentToAdd] = useState();
  const [relatedResponsible, setRelatedResponsible] = useState([]);
  const [responsibleSelectedEmail, setResponsibleSelectedEmail] = useState('');
  const [studentResponsibleRelationData, setStudentResponsibleRelationData] =
    useState({});
  const [enrollmentModal, setEnrollmentModal] = useState(false);
  const [responsibleModal, setResponsibleModal] = useState(false);
  const [enrollmentToDelete, setEnrollmentToDelete] = useState({});
  const [responsibleToDelete, setResponsibleToDelete] = useState({});
  const [profilePhotoUrl, setProfilePhotoUrl] = useState();
  const [periodDate, setPeriodDate] = useState();

  const loadStudentEnrollments = (studentId) => {
    const query = relationStudentClassListByStudent(studentId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.relationStudentClassListByStudent =
          res.relationStudentClassListByStudent.map((item) => ({
            ...item,
            activeDescription: t(`general.yesno.${item.active}`),
            initialDate: format(
              getDateWithoutTime(item.initialDateInMilli),
              'dd/MM/yyyy'
            ),
            finalDate: item.finalDateInMilli
              ? format(getDateWithoutTime(item.finalDateInMilli), 'dd/MM/yyyy')
              : '',
          }));
        let updatedHistoricEnrollments = res.relationStudentClassListByStudent;
        if (historicEnrollments.length) {
          updatedHistoricEnrollments = updatedHistoricEnrollments.concat([
            ...historicEnrollments,
          ]);
          updatedHistoricEnrollments = updatedHistoricEnrollments.filter(
            (el, index, self) => {
              return (
                index ===
                self.findIndex(
                  (relation) =>
                    relation.id === el.id &&
                    relation.schoolClass.id === el.schoolClass.id &&
                    relation.schoolShift.id === el.schoolShift.id &&
                    relation.initialDateInMilli === el.initialDateInMilli
                )
              );
            }
          );
        }
        setHistoricEnrollments(updatedHistoricEnrollments);
        change('classEnrollments', updatedHistoricEnrollments);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.error-to-loading')
        );
      });
  };

  const loadStudentClassToEnroll = (studentId) => {
    const query = relationStudentActiveClassListToEnroll(studentId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.relationStudentActiveClassListToEnroll =
          res.relationStudentActiveClassListToEnroll.map((item) => ({
            ...item,
            value: item.id,
            label: `${item.schoolClass.name}(${item.schoolShift.name})`,
            initialDateInMilli:
              new Date().getTime() > item.period.finalDate
                ? item.period.finalDate
                : new Date().getTime(),
            initialDate: format(
              new Date().getTime() > item.period.finalDate
                ? new Date(item.period.finalDate)
                : new Date(),
              'dd/MM/yyyy'
            ),
            active: true,
            activeDescription: t(`general.yesno.${true}`),
          }));
        setAvailableEnrollments(res.relationStudentActiveClassListToEnroll);
        hideLoading();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-loading')
        );
        hideLoading();
      });
  };

  const loadStudentResponsible = (studentId) => {
    const query = responsibleStudentRelationListByStudent(studentId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.responsibleStudentRelationListByStudent =
          res.responsibleStudentRelationListByStudent.map((item) => ({
            ...item,
            typeDescription: t(`responsible-kindship.${item.type}`),
            accessStudentDataDescription: t(
              `general.yesno.${!!item.accessStudentData}`
            ),
            takeStudentDescription: t(`general.yesno.${!!item.takeStudent}`),
            emergencyContactDescription: t(
              `general.yesno.${!!item.emergencyContact}`
            ),
            financialContactDescription: t(
              `general.yesno.${!!item.financialContact}`
            ),
            phones: concatPhones(item.responsible),
          }));
        setRelatedResponsible(res.responsibleStudentRelationListByStudent);
        change(
          'relatedResponsible',
          res.responsibleStudentRelationListByStudent
        );
        hideLoading();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-loading')
        );
        hideLoading();
      });
  };
  const onClassEnrollChange = (value) => {
    setClassEnrollmentToAdd(value);
    change(
      'enrollmentDate',
      new Date() > value.period.finalDate ? value.period.finalDate : new Date()
    );
    setPeriodDate(value.period);
  };

  const toggleTab = (index) => {
    setActiveTab(index);
  };

  const selectedEmailChangeHandler = (email) => {
    setResponsibleSelectedEmail(email);
  };

  const saveResponsible = (values) => {
    showLoading();
    const mutationQuery = responsibleSaveMutation(
      values,
      !!values.financialContact
    );
    GraphQL(mutationQuery, {
      firstName: values.firstName,
      lastName: values.lastName,
      fullName: values.fullName,
    })
      .then((res) => {
        hideLoading();
        const studentResponsibleRelationToAdd = {
          id: 0,
          type: values.relationKindShip ? values.relationKindShip.value : 'U',
          typeDescription: t(
            `responsible-kindship.${
              values.relationKindShip ? values.relationKindShip.value : 'U'
            }`
          ),
          accessStudentData: !!values.accessStudentData,
          accessStudentDataDescription: t(
            `general.yesno.${!!values.accessStudentData}`
          ),
          takeStudent: !!values.takeStudent,
          takeStudentDescription: t(`general.yesno.${!!values.takeStudent}`),
          emergencyContact: !!values.emergencyContact,
          emergencyContactDescription: t(
            `general.yesno.${!!values.emergencyContact}`
          ),
          financialContact: !!values.financialContact,
          financialContactDescription: t(
            `general.yesno.${!!values.financialContact}`
          ),
          phones: concatPhones(values),
          responsible: {
            ...values,
            id: res.responsibleSave.id,
          },
        };
        let updatedRelatedResponsible = [...relatedResponsible];
        const respIndex = updatedRelatedResponsible.findIndex(
          (item) =>
            studentResponsibleRelationToAdd.responsible.email ===
            item.responsible.email
        );
        if (respIndex < 0) {
          updatedRelatedResponsible = [studentResponsibleRelationToAdd].concat(
            updatedRelatedResponsible
          );
        } else {
          studentResponsibleRelationToAdd.id =
            updatedRelatedResponsible[respIndex].id;
          updatedRelatedResponsible[respIndex] =
            studentResponsibleRelationToAdd;
        }
        setRelatedResponsible(updatedRelatedResponsible);
        setResponsibleSelectedEmail('');
        setStudentResponsibleRelationData({});
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const handleRespSubmit = (values) => {
    if (values.financialContact) {
      if (!values.cpf || !values.zipCode) {
        showNotificationAutoDestroy(
          'warning',
          t('notifications.attention'),
          t('notifications.warning-no-documents')
        );
      } else {
        saveResponsible(values);
      }
    } else {
      saveResponsible(values);
    }
  };

  const addEnrollment = () => {
    if (classEnrollmentToAdd) {
      let updatedHistoricEnrollments = [];
      updatedHistoricEnrollments.push(classEnrollmentToAdd);
      updatedHistoricEnrollments =
        updatedHistoricEnrollments.concat(historicEnrollments);
      setHistoricEnrollments(updatedHistoricEnrollments);
      const updatedAvailableEnrollments = availableEnrollments.filter(
        (item) => item.schoolShift.id !== classEnrollmentToAdd.schoolShift.id
      );
      setAvailableEnrollments(updatedAvailableEnrollments);
      change('classEnrollments', updatedHistoricEnrollments);
      change('studentClassRelationToAdd', null);
      setClassEnrollmentToAdd();
    }
  };

  const editResponsibleItemClickHandler = (evt, rowData) => {
    const responsibleEmail = rowData.responsible.email;
    const selectedStudentResponsibleRelationData = {
      accessStudentData: rowData.accessStudentData,
      emergencyContact: rowData.emergencyContact,
      takeStudent: rowData.takeStudent,
      financialContact: rowData.financialContact,
      type: rowData.type,
    };
    setStudentResponsibleRelationData(selectedStudentResponsibleRelationData);
    setResponsibleSelectedEmail(responsibleEmail);
  };

  const cancelResponsibleEditionHandler = () => {
    setStudentResponsibleRelationData({});
    setResponsibleSelectedEmail('');
  };

  const toggleEnrollmentModal = () => {
    setEnrollmentModal(!enrollmentModal);
  };

  const toggleResponsibleModal = () => {
    setResponsibleModal(!responsibleModal);
  };

  const removeResponsibleItemClickHandler = (evt, rowData) => {
    toggleResponsibleModal();
    setResponsibleToDelete(rowData);
  };

  const deleteResponsible = () => {
    if (responsibleToDelete.id > 0) {
      const removeMutation = responsibleStudentRelationRemoveMutation(
        responsibleToDelete.id
      );
      GraphQL(removeMutation, {})
        .then(() => {
          loadStudentResponsible(dto.id);
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-removed')
          );
        })
        .catch(() => {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-remove')
          );
        });
    } else {
      const updatedRelatedResponsible = relatedResponsible.filter(
        (item) =>
          item.responsible.email !== responsibleToDelete.responsible.email
      );
      setRelatedResponsible(updatedRelatedResponsible);
    }
    toggleResponsibleModal();
  };

  const relationStudentClassRemove = (id) => {
    const removeEnrolmentMutation = relationStudentClassRemoveById(id);
    showLoading();
    GraphQL(removeEnrolmentMutation, {})
      .then(() => {
        loadStudentEnrollments(dto.id);
        hideLoading();
        toggleEnrollmentModal();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
        hideLoading();
      });
  };

  const deleteEnrolmentItem = () => {
    if (enrollmentToDelete.id) {
      relationStudentClassRemove(enrollmentToDelete.id);
    } else {
      const updateHistoricEnrollments = [...historicEnrollments];
      const index = updateHistoricEnrollments.findIndex(
        (historic) =>
          historic.id === enrollmentToDelete.id &&
          historic.schoolClass.id === enrollmentToDelete.schoolClass.id &&
          historic.schoolShift.id === enrollmentToDelete.schoolShift.id &&
          historic.initialDateInMilli === enrollmentToDelete.initialDateInMilli
      );
      updateHistoricEnrollments.splice(index, 1);
      setHistoricEnrollments(updateHistoricEnrollments);
      change('classEnrollments', updateHistoricEnrollments);
      toggleEnrollmentModal();
    }
  };

  const profilePhotoChangeHandler = (file) => {
    if (file) {
      change('fileId', file.fileId);
      change('profilePhotoUrl', file.fileUrl);
      setProfilePhotoUrl(file.fileUrl);
    }
  };

  const onSelectedEnrollmentDate = (date) => {
    const updatedClassEnrollmentToAdd = {
      ...classEnrollmentToAdd,
      initialDate: format(new Date(date), 'dd/MM/yyyy'),
      initialDateInMilli: date.getTime(),
    };
    setClassEnrollmentToAdd(updatedClassEnrollmentToAdd);
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).hidden =
        (copyProps.data.active && copyProps.data.id !== 0) ||
        !copyProps.data.active;
      copyProps.actions.find(
        (a) => a.name === ACTION_NAME.ACCOUNT_MINUS
      ).hidden = !copyProps.data.active || copyProps.data.id === 0;
    }
  };

  const handleCpfBlur = (evt) => {
    const cpfValue = evt.target.value;
    if (cpfValue) {
      if (cpf.isValid(cpfValue)) {
        loadExistStudentByCpf(cpfValue);
      }
    }
  };

  useEffect(() => {
    initialize(dto);
    if (dto.id) {
      loadStudentEnrollments(dto.id);
      loadStudentResponsible(dto.id);
      if (dto.profilePhotoUrl) {
        setProfilePhotoUrl(dto.profilePhotoUrl);
        change('fileId', dto.fileId);
      }
    }
    loadStudentClassToEnroll(dto.id);
  }, [dto]);

  useEffect(() => {
    if (fullName.trim()) {
      change('fullName', fullName);
    }
  }, [fullName]);

  useEffect(() => {
    change('relatedResponsible', relatedResponsible);
  }, [relatedResponsible]);

  const removeEnrollmentItemClickHandler = (evt, rowData) => {
    toggleEnrollmentModal();
    setEnrollmentToDelete(rowData);
  };

  const onFirstNameAndLastNameKeyPressHandler = (event) => {
    if (
      event &&
      event.target &&
      REGEX_NO_EXPRESSIONS.test(event.target.value)
    ) {
      event.preventDefault();
    }
  };

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={
          enrollmentToDelete.id
            ? t('notifications.unenroll-student')
            : t('notifications.delete_modal')
        }
        toggle={toggleEnrollmentModal}
        modal={enrollmentModal}
        onConfirm={deleteEnrolmentItem}
      />
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleResponsibleModal}
        modal={responsibleModal}
        onConfirm={deleteResponsible}
      />
      <form className="form" onSubmit={handleSubmit}>
        <Col md={12} lg={12} xl={12}>
          <div className="tabs tabs--justify tabs--bordered-bottom">
            <div className="tabs__wrap">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === ACTIVE_TAB.ONE,
                    })}
                    onClick={() => {
                      toggleTab(ACTIVE_TAB.ONE);
                    }}
                  >
                    {t('general.personal-data')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === ACTIVE_TAB.TWO,
                    })}
                    onClick={() => {
                      toggleTab(ACTIVE_TAB.TWO);
                    }}
                  >
                    {t('general.responsible')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === ACTIVE_TAB.THREE,
                    })}
                    onClick={() => {
                      toggleTab(ACTIVE_TAB.THREE);
                    }}
                  >
                    {t('general.medical-notes')}
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1" className="form">
                  <div className="form__form-group--centered">
                    <SmartAvatar
                      avatarSrc={profilePhotoUrl}
                      avatarChangeHandler={profilePhotoChangeHandler}
                      id={dto.id}
                    />
                  </div>
                  <div className="form__form-group--2_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.first-name')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="firstName"
                          type="text"
                          component={renderField}
                          maxLength="50"
                          placeholder={t('placeholder.student.firstName')}
                          onChange={onFirstNameAndLastNameKeyPressHandler}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.last-name')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="lastName"
                          type="text"
                          component={renderField}
                          maxLength="50"
                          placeholder={t('placeholder.student.lastName')}
                          onChange={onFirstNameAndLastNameKeyPressHandler}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group--2_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.full-name')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="fullName"
                          type="text"
                          component={renderField}
                          maxLength="100"
                          placeholder={t('placeholder.student.fullName')}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.short-name')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="shortName"
                          type="text"
                          component={renderField}
                          onChange={onFirstNameAndLastNameKeyPressHandler}
                          maxLength="25"
                          placeholder={t('placeholder.student.shortName')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('general.email')}
                    </span>
                    <div className="form_form-group-field">
                      <Field
                        name="email"
                        component={renderField}
                        placeholder={t(
                          'general.placeholders.smart-student-email'
                        )}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form__form-group--3_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.date-of-birth')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="dateOfBirth"
                          component={DateField}
                          placeholder={t('placeholder.student.dateOfBirth')}
                          maxDate={new Date()}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.cpf')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="cpf"
                          type="text"
                          component={renderField}
                          placeholder={t('placeholder.student.cpf')}
                          {...cpfMasker()}
                          onBlur={handleCpfBlur}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.gender')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="gender"
                          component={genderSelector}
                          color="primary"
                          t={t}
                        />
                      </div>
                    </div>
                  </div>
                  <AddressInfo
                    t={t}
                    showLoading={showLoading}
                    hideLoading={hideLoading}
                    change={change}
                  />
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('general.menu')}
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="enrolledMenu"
                        type="text"
                        options={menus}
                        component={Select}
                        placeholder={t('placeholder.student.enrolledMenu')}
                      />
                    </div>
                  </div>
                  <div className="form__form-group--3_columns_date_button">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.enrollments')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="studentClassRelationToAdd"
                          type="text"
                          options={availableEnrollments}
                          component={Select}
                          onChange={onClassEnrollChange}
                          placeholder={t(
                            'placeholder.student.class-enrollment'
                          )}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.enrollmentDate')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="enrollmentDate"
                          type="text"
                          component={DateField}
                          onChange={onSelectedEnrollmentDate}
                          placeholder={t('general.enrollmentDate')}
                          minDate={
                            periodDate
                              ? getDateWithoutTime(periodDate.initialDate)
                              : null
                          }
                          maxDate={
                            periodDate
                              ? getDateWithoutTime(periodDate.finalDate)
                              : null
                          }
                        />
                      </div>
                    </div>
                    <div className="btn-form-group">
                      <Button color="success" onClick={addEnrollment}>
                        {t('general.add')}
                      </Button>
                    </div>
                  </div>

                  <div className="form__form-group">
                    <MatTable
                      data={historicEnrollments}
                      toolbar={false}
                      columns={enrollmentsColumns(t)}
                      onRemoveClick={removeEnrollmentItemClickHandler}
                      actionsDisabled
                      actionsDisabledByConditional={
                        actionsDisabledByConditional
                      }
                      customAction={{
                        name: ACTION_NAME.ACCOUNT_MINUS,
                        icon: (
                          <Icon
                            path={mdiAccountMinus}
                            horizontal
                            vertical
                            size={1}
                            rotate={180}
                            color="#6a2b8b"
                            id="mdiNeedle"
                          />
                        ),
                        tooltip: t('tooltips.student-minus'),
                        callback: removeEnrollmentItemClickHandler,
                      }}
                    />
                  </div>
                  <div className="form__form-group--3_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.barcode')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="barcode"
                          type="text"
                          component={renderField}
                          maxLength="250"
                          placeholder={t('placeholder.student.barcode')}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.external-id')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="legacyId"
                          type="number"
                          component={renderField}
                          placeholder={t('placeholder.student.legacyId')}
                          maxLength="10"
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.agreement')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="studentOrigin"
                          type="text"
                          component={Select}
                          options={STUDENT_AGREEMENT(t)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('general.observations')}
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="observations"
                        type="text"
                        component="textarea"
                        maxLength="2000"
                        placeholder={t('placeholder.student.observations')}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <div className="form__form-group-field">
                      <Label className="generic__label">
                        {t('general.active')}
                      </Label>
                      <Field
                        name="active"
                        component={renderCheckBoxField}
                        className="colored-click"
                      />
                    </div>
                  </div>
                </TabPane>
              </TabContent>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="2" className="form">
                  <ResponsibleForm
                    onSubmit={handleRespSubmit}
                    backHandler={backHandler}
                    showLoading={showLoading}
                    hideLoading={hideLoading}
                    studentForm
                    cancelEdit={cancelResponsibleEditionHandler}
                    studentRelationData={studentResponsibleRelationData}
                    selectedEmail={responsibleSelectedEmail}
                    selectedEmailChangeHandler={selectedEmailChangeHandler}
                  />
                  <div className="form__form-group mt-3">
                    <span className="form__form-group-label">
                      {t('general.registered-responsible')}
                    </span>
                  </div>
                  <div className="form__form-group">
                    <MatTable
                      data={relatedResponsible}
                      columns={responsibleStudentColumns(t)}
                      onEditClick={editResponsibleItemClickHandler}
                      onRemoveClick={removeResponsibleItemClickHandler}
                      toolbar={false}
                      paging={false}
                    />
                  </div>
                </TabPane>
              </TabContent>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="3" className="form">
                  <MedicalInfo t={t} />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Col>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

StudentForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.objectOf(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  fullName: PropTypes.string,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  menus: PropTypes.arrayOf(PropTypes.shape).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setHistoricEnrollments: PropTypes.func.isRequired,
  historicEnrollments: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  loadExistStudentByCpf: PropTypes.func.isRequired,
};

StudentForm.defaultProps = {
  fullName: '',
};

const selector = formValueSelector('StudentForm');

export default withTranslation('common')(
  reduxForm({
    form: 'StudentForm',
    validate,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(
    connect((state) => {
      const { firstName, lastName } = selector(state, 'firstName', 'lastName');
      const newState = {
        firstName,
        lastName,
        fullName: `${firstName || ''} ${lastName || ''}`,
      };
      return newState;
    })(StudentForm)
  )
);
